import config from "@/config";
import { requests } from ".";

const SURVEY_SERVER_URL = config?.SURVEY_SERVER_URL;

interface GetSurveys {
  limit: number;
  skip: number;
  type: string;
  locationId: string;
  query: string;
  parentId?: string;
}
interface CreateForm {
  locationId: string;
  parentId?: string;
}

interface CreateSurvey {
  locationId: string;
  parentId?: string;
  source: string;
}

interface UpdateFolder {
  name: string;
  id: string;
}
interface DeleteForm {
  formId: string;
}

interface DuplicateForm {
  formId: string;
  name: string;
}
interface CreateFolder {
  name: string;
  locationId: string;
}

interface GetFolder {
  folderId: string;
}

interface ListFolders {
  locationId: string;
}
interface ShareForm {
  formId: string;
  locationId: string;
}

interface MoveToFolder {
  formId: string;
  folderId: string;
}

interface UpdateFormById {
  name: string;
  formData: {
    form: {
      company: {
        domain: string;
        logoUrl: string;
        name: string;
      };
      customStyle: string;
      fieldCSS: string;
      fbPixelId: string;
      fieldStyle: string;
      fields: Array<{}>;
      formAction: {
        actionType: string;
        redirect_url: string;
        thankyouText: string;
      };
      formLabelVisible: boolean;
      formSubmissionEvent: string;
      height: number;
      layout: boolean;
      pageViewEvent: string;
      stickyContact: boolean;
      style: {
        acBranding: boolean;
        background: string;
        border: object;
        padding: object;
        shadow: object;
      };
      submitMessageStyle: object;
      width: number;
    };
  };
}

export const SurveyServices = {
  getSurveys: (params: GetSurveys) => requests(SURVEY_SERVER_URL).get("/surveys/", { params }),
  getSurveyById: (id: string) => requests(SURVEY_SERVER_URL).get(`/surveys/${id}`),
  createForm: (params: CreateForm) => requests(SURVEY_SERVER_URL).post("/forms/", params),
  createSurvey: (params: CreateSurvey) => requests(SURVEY_SERVER_URL).post("/surveys/", params),
  deleteForm: (params: DeleteForm) => requests(SURVEY_SERVER_URL).delete(`/forms/${params.formId}`),
  duplicateForm: (params: DuplicateForm) =>
    requests(SURVEY_SERVER_URL).post(`/forms/duplicate/${params.formId}`, {
      name: params.name,
    }),
  createFolder: (params: CreateFolder) =>
    requests(SURVEY_SERVER_URL).post(`/forms/folder/`, params),
  getFolder: (params: GetFolder) =>
    requests(SURVEY_SERVER_URL).get(`/forms/folder/${params.folderId}`),
  listFolders: (params: ListFolders) =>
    requests(SURVEY_SERVER_URL).get(`/forms/folder`, { params }),
  moveToFolder: (params: MoveToFolder) =>
    requests(SURVEY_SERVER_URL).post(`/forms/move-to-folder`, params),
  updateFolder: (params: UpdateFolder) =>
    requests(SURVEY_SERVER_URL).post(`/forms/folder/${params.id}`, {
      name: params.name,
    }),
  shareForm: (params: ShareForm) => {
    const { formId, locationId } = params;
    return requests(SURVEY_SERVER_URL).post(`/forms/share/${formId}`, {
      locationId,
    });
  },
  imageUpload: (body) =>
    requests(SURVEY_SERVER_URL).post(`/surveys/image?locationId=${body.get("locationId")}`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  updateFormById: (id: String, body: any) =>
    requests(SURVEY_SERVER_URL).post(`/surveys/${id}`, body),
  getThemes: (locationId: string) =>
    requests(SURVEY_SERVER_URL).get(`/surveys/themes?locationId=${locationId}`),
  getThemeStyles: (themeId: string, locationId: string) =>
    requests(SURVEY_SERVER_URL).get(`/surveys/theme-style/${themeId}?locationId=${locationId}`),
  restoreSurveyVersion: (body: any) =>
    requests(SURVEY_SERVER_URL).post(`/surveys/restore-version`, body),
};
